import { Reducer } from 'redux'

import { BudgetActionTypes } from './actions'
import { reducerName } from './modals/actions'
import { MODALS } from './modals/types'

import { IAdAccount } from '@/store/adaccounts/types'

export interface IModal {
  name: MODALS
  data?: any
}

export interface IAccountsListType {
  count: number
  current: number
  next: number | null
  page_count: number
  previous: number | null
  loading: boolean
  results: IAdAccount[] | []
}

export interface IBudgetState {
  modals: IModal | null
  redirect: string
  accountsFromSelectedList: IAccountsListType
  accountsToSelectedList: IAccountsListType
}

const initialList = {
  count: 0,
  current: 0,
  next: null,
  page_count: 0,
  previous: null,
  results: [],
  loading: false,
}

export const initialState: IBudgetState = {
  modals: null,
  redirect: '',
  accountsFromSelectedList: initialList,
  accountsToSelectedList: initialList,
}

const budgetReducer: Reducer<IBudgetState> = (state = initialState, action: any) => {
  switch (action.type) {
    case BudgetActionTypes.SET_ACCOUNTS_FROM_SELECTED_LOADING: {
      return { ...state, accountsFromSelectedList: { ...state.accountsFromSelectedList, loading: true } }
    }
    case BudgetActionTypes.SET_ACCOUNTS_FROM_SELECTED_STOP_LOADING: {
      return { ...state, accountsFromSelectedList: { ...state.accountsFromSelectedList, loading: false } }
    }
    case BudgetActionTypes.SET_ACCOUNTS_FROM_SELECTED: {
      const { results, ...listParams } = action.data

      return {
        ...state,
        accountsFromSelectedList: {
          ...listParams,
          loading: false,
          results: [...state.accountsFromSelectedList.results, ...results],
        },
      }
    }
    case BudgetActionTypes.CLEAR_ACCOUNTS_FROM_SELECTED: {
      return { ...state, accountsFromSelectedList: initialList }
    }
    case BudgetActionTypes.SET_ACCOUNTS_TO_SELECTED_LOADING: {
      return { ...state, accountsToSelectedList: { ...state.accountsToSelectedList, loading: true } }
    }
    case BudgetActionTypes.SET_ACCOUNTS_TO_SELECTED_STOP_LOADING: {
      return { ...state, accountsToSelectedList: { ...state.accountsToSelectedList, loading: false } }
    }
    case BudgetActionTypes.SET_ACCOUNTS_TO_SELECTED: {
      const { results, ...listParams } = action.data

      return {
        ...state,
        accountsToSelectedList: {
          ...listParams,
          loading: false,
          results: [...state.accountsToSelectedList.results, ...results],
        },
      }
    }
    case BudgetActionTypes.CLEAR_ACCOUNTS_TO_SELECTED: {
      return { ...state, accountsToSelectedList: initialList }
    }
    case BudgetActionTypes.SET_BUDGET_REDIRECT: {
      return { ...state, redirect: action.data }
    }
    case `${reducerName}.OPEN_MODAL`: {
      return {
        ...state,
        modals: action.payload,
      }
    }
    case `${reducerName}.CLOSE_MODAL`: {
      return {
        ...state,
        modals: null,
      }
    }
    default: {
      return state
    }
  }
}

export default budgetReducer
